import { combineReducers } from 'redux';
import { authentication } from './user.reducer';
import { alerts } from './alerts.reducer';
import { ticket } from './ticket.reducer';
import { previewFile } from './preview-file.reducer';
import { uploadingFiles } from './file.reducer';
import { bookingInfoRes } from './booking-info.reducer';
import { showOverlay } from './show-overlay.reducer';
import { inboxes } from './inboxes.reducer';
import { workdeskFilter } from './workdesk-filter.reducer';
import { workdeskTickets } from './workdesk-tickets.reducer';
import { numTickets } from './num-tickets.reducer';
import { unlockFile } from './unlock.reducer';
import { curBookings } from './cur-bookings.reducer';
import { ticketGroupTable } from './ticket-group-table.reducer';
import { websocket } from './websocket.reducer';
import { assignees } from './assignees.reducer';
import { forDownload } from './download.reducer';
import { countries } from './countries.reducer';

const rootReducer = combineReducers({
  authentication,
  alerts,
  ticket,
  previewFile,
  uploadingFiles,
  bookingInfoRes,
  showOverlay,
  inboxes,
  workdeskFilter,
  workdeskTickets,
  numTickets,
  unlockFile,
  curBookings,
  ticketGroupTable,
  websocket,
  assignees,
  forDownload,
  countries,
});

export default rootReducer;
